<script>
	let classes = 'flex w-full flex-1 flex-col pb-3 pt-5';
	export { classes as class };
</script>

<div class={classes}>
	<slot />
</div>
